<template>
  <input
    class="input"
    type="number"
    v-model.number="fieldData.value"
    :class="classes"
    :placeholder="FIELD_TYPE_NAMES[fieldDefinition.type]"
    :step="fieldDefinition.type === 'float' ? 'any' : 1"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  />
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { FIELD_TYPE_NAMES } from '@/config'

import { type FieldModel, type FieldProps, ValidationError, defineValidator } from '.'

type Constraint = { type: 'int' | 'float'; many: false }
const { fieldDefinition } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

const classes = computed(() => ({
  'is-danger': !fieldData.value.valid,
  'is-loading': fieldData.value.loading,
}))

const { localErrors } = defineValidator(fieldDefinition, fieldData.value, (value: unknown) => {
  if (!fieldDefinition.required && value === null) return
  if (typeof value !== 'number' || !Number.isFinite(value))
    throw new ValidationError(['This is not a valid number'])
  if (fieldDefinition.type === 'int' && !Number.isInteger(value))
    throw new ValidationError(['This number must be an integer'])
})
</script>
